import { render, staticRenderFns } from "./ModelOrders.vue?vue&type=template&id=25e175c4&"
import script from "./ModelOrders.vue?vue&type=script&lang=js&"
export * from "./ModelOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports